import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  remove as removeNotification,
  add as addNotification,
} from "../../redux-store/notificationsSlice";
import { TextField } from "@mui/material";
import ModalComponent from "../../components/Modal";
import ConfirmForm from "../../components/Forms/confirmForm";

const ReviewReport = ({
  reportTitle,
  reviewerName,
  handleClose,
  handleSave,
}) => {
  const [comments, setComments] = useState("");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const handlers = {
    save: async () => {
      if (loading) return;

      setLoading(true);
      try {
        await handleSave(comments);
      } catch (err) {
        console.log(err);
        const id = new Date().getTime();
        dispatch(
          addNotification({
            id,
            severity: "error",
            title: "Error",
            message: err.message || String(err),
          })
        );
        setTimeout(() => {
          dispatch(removeNotification(id));
        }, 3000);
        setLoading(false);
      }
    },
  };
  return (
    <ModalComponent
      open
      headerText="Review Compliance Report"
      handleClose={loading ? () => {} : handleClose}
    >
      <ConfirmForm
        handleCancel={loading ? () => {} : handleClose}
        handleSave={handlers.save}
        cancelButtonText="Cancel"
        saveButtonText="Save Review"
        loading={loading}
      >
        <p>
          <strong>{reportTitle}</strong>
        </p>
        <div>
          Reviewer: <strong>{reviewerName}</strong>
        </div>
        <div>
          By clicking Save Review, you agree that you have reviewed the tank
          health and alarm information for this period. Your name, review date,
          and comments will appear on the report.
        </div>
        <TextField
          label="Reviewer comments (optional)"
          multiline
          minRows={3}
          value={comments}
          onChange={(event) => setComments(event.target.value)}
          inputProps={{ maxLength: 2000 }}
          fullWidth
        />
      </ConfirmForm>
    </ModalComponent>
  );
};

export default ReviewReport;
